import React from 'react';
import {
  Button, Col, Form, Input, message, Modal, Row, Select,
} from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';

const CreateModal = ({
  isOpen = false,
  availableUsersOptions = [],
  availableBoardsOptions = [],
  onClose = (_) => {},
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = (values) => {
    const csrf = document.head.querySelector("[name='csrf-token']").content;

    axios({
      headers: { 'X-CSRF-Token': csrf },
      method: 'post',
      url: '/tickets',
      data: values,
    }).then((response) => {
      messageApi.success('Заявку успішно створено');
      onClose(response.data);
    }).catch((error) => {
      const errorMessage =
        error?.response?.data?.errors?.join('; ') || 'Помилка при створенні заявки';
      messageApi.error(errorMessage);
      console.error(error);
    });
  };

  return (
    <Modal
      title="Нова заявка"
      open={isOpen}
      onCancel={() => onClose(null)}
      footer={null}
      width={1000}
      destroyOnHidden
    >
      {contextHolder}
      <Form
        onFinish={handleSubmit}
        preserve={false}
        variant="filled"
        initialValues={{ status: 'open' }}
      >
        <Row gutter={5}>
          <Col span={16}>
            <Form.Item
              name="title"
              rules={[{ required: true, message: 'Введіть назву заявки' }]}
            >
              <Input placeholder="Назва" />
            </Form.Item>
            <Form.Item name="description">
              <Input.TextArea
                placeholder="Опис"
                autoSize={{ minRows: 10, maxRows: 17 }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="user_id"
              rules={[{ required: true, message: 'Оберіть автора' }]}
            >
              <Select
                placeholder="Автор"
                options={availableUsersOptions}
                showSearch
                allowClear
              />
            </Form.Item>
            <Form.Item name="responsible_id">
              <Select
                placeholder="Виконавець"
                options={availableUsersOptions}
                showSearch
                allowClear
              />
            </Form.Item>
            <Form.Item name="board_id">
              <Select
                placeholder="Дошка"
                options={availableBoardsOptions}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" htmlType="submit">Створити</Button>
      </Form>
    </Modal>
  );
};

CreateModal.propTypes = {
  isOpen: PropTypes.bool,
  availableUsersOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  availableBoardsOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  onClose: PropTypes.func,
};

export default CreateModal;
